'use strict';

app.directive('oasImgSrc', function oasImgSrc(APP_CONFIG) {
    var attrName = "src";
    var normalized = "oasImgSrc";
    return {
        priority: 99,
        link: function (scope, element, attrs) {
            attrs.$observe(normalized, function(value) {
                //NOTE: Make sure to include a blank src attribute on the element or IE throws up.
                //      See ngSrc code for more information.

                if (!value) return;

                var requiresToken = attrs.requiresToken ? scope.$eval(attrs.requiresToken) : true;

                if (requiresToken && sessionStorage.oas_token)
                    attrs.$set(attrName, APP_CONFIG.baseApiUrl + value + (value.indexOf("?") !== -1 ? "&" : "?") + "Authorization=" + sessionStorage.oas_token);
                else if (!requiresToken)
                    attrs.$set(attrName, APP_CONFIG.baseApiUrl + value);

                //TODO: issue in IE, commenting out for now
//                element.one("error", function(e) {
//                    e.preventDefault();
//                    e.stopPropagation();
//
//                    attrs.$set(attrName, "");
//                    return true;
//                });
            });
        }
    };
});
'use strict';

app.directive('iframeResizer', function iframeResizer() {
    return {
        link: function (scope, element, attrs) {
            setTimeout(function() {
                const defaultOptions = {
                    enablePublicMethods: true,
                    checkOrigin: false,
                    //log: true,
                    //initCallback: function(messageData) { console.log("INIT: " + messageData); },
                    //resizedCallback: function(messageData) { console.log("RESIZED: " + messageData); },
                    //messageCallback: function(messageData) { console.log("MESSAGE: " + messageData); },
                    //closedCallback: function(id) { console.log("CLOSED: " + id); }
                };

                const extendedOptions = attrs.iframeResizer.length ? angular.extend(defaultOptions, JSON.parse(attrs.iframeResizer)) : defaultOptions;

                iFrameResize(extendedOptions, '#' + attrs.id);
            }, 10);
        }
    };
});

app.directive('autoHeight', function autoHeight($window, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            function setHeight() {
                var offset = attrs.autoHeightOffset ? parseInt(attrs.autoHeightOffset) : 0;
                var height = $window.innerHeight - element.prop('offsetTop') - offset;

                element.css('height', height + 'px');
            }

            angular.element($window).bind('resize', setHeight);

            $timeout(setHeight, 200);
            element.css("overflow", "auto");

            scope.$on('$destroy', function cleanUpAutoHeight() {
                angular.element($window).unbind('resize', setHeight);
            });
        }
    };
});
